/*
 * @Descripttion: 封装数据请求
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-10-25 21:44:24
 */
import axios from "axios";
import { Message } from "element-ui";
import qs from "qs";
import { errCodeData } from "@/api/errCode";
// 1.创建新的axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    // const accessToken =
    //   store.state.accessToken || localStorage.getItem("accessToken");
    const accessToken =
      localStorage.getItem("accessToken") ||
      `eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE2OTc5MTE3NDksInVzZXJLZXkiOiI2NzE3MDQ4NjQ3Mjc3Njc1MDE3In0.Pzv3CcsKGqEg5dnGvNLibuPpQFpruyLdhGKEIWOF3yzynrCc22Wazey0T83v2jHo7loQkq_EbQthnRTqGIYHQQ`;
    if (accessToken) {

      config.headers.accessToken = accessToken;
    }
    config.headers.JgbAuthorization = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImUwMDEyZDFmLTE2YjAtNGVhOC05MzNkLWYxOTQyYzQyMDNmOSJ9.FIb8QAa9gyt01S45DOAyAIKmOtJZ7Uo3_LXGzj_iFoeT-ton7rN1HBJJluK8hLzpK6QSf5GTV_0Zt4EN4EM5EQ'
    // 发请求前做的一些处理，数据转化，配置请求头等，根据需求去添加
    // config.headers = {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // };

    // 判断请求的类型
    // 如果是post请求就把默认参数拼到data里面
    // 如果是get请求就拼到params里面
    if (config.method === "post") {
      let contentType = config.contentType;
      if (contentType && contentType == "application/x-www-form-urlencoded") {
        let data = qs.parse(config.data);
        config.data = qs.stringify({
          // ...admParam(),
          ...data,
        });
        config.headers = {
          "Content-Type": contentType,
        };
      } else {
        let data = config.data;
        config.data = {
          // ...admParam(),
          ...data,
        };
      }
    } else if (config.method === "get") {
      config.params = {
        // ...admParam(),
        ...config.params,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 3.响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const flag = errCodeData.findIndex((item) => item.code == res.errCode);
    // 状态码非1并且errCode不在errCode码表
    if (res.code != 200 && flag == -1) {
      Message({
        message: res.message || "Error",
        type: "error",
        duration: 2000,
      });

      if (response.data.errCode == 900028) {
        window.location.href = `${window.location.origin}/login`;
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: "error",
      duration: 2000,
    });
    return Promise.reject(error);
  }
);
export default service;
